import { render, staticRenderFns } from "./repayReportForBeginRoiDate.vue?vue&type=template&id=5d1090ea&scoped=true"
import script from "./repayReportForBeginRoiDate.vue?vue&type=script&lang=js"
export * from "./repayReportForBeginRoiDate.vue?vue&type=script&lang=js"
import style0 from "./repayReportForBeginRoiDate.vue?vue&type=style&index=0&id=5d1090ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1090ea",
  null
  
)

export default component.exports